import httpService from "../../../../services/httpService";

export interface OrganizationContact {
  name?: string | null;
  phone?: string | null;
  email?: string | null;
}

export interface OrganizationProfile {
  organization_id?: string;
  name: string;
  email: string;
  company_id?: string | null;
  company_name?: string | null;
  contact?: OrganizationContact | null;
  location?: string | null;
  industry?: string | null;
  active_jobs?: number;
  logo_s3_key?: string | null;
  logo_url?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
}

export interface OrganizationListView {
  total_no_of_records: number;
  no_of_records: number;
  records: OrganizationProfile[];
}

class OrganizationClient {
  private basePath = "/organizations";

  async listOrganizations(
    page: number = 1,
    limit: number = 10,
    name?: string,
    sort_order: string = "asc"
  ): Promise<OrganizationListView> {
    const params: Record<string, any> = {
      page_number: page,
      limit,
      sort_order,
    };
    if (name && name.trim()) {
      params.name = name.trim();
    }
    const response = await httpService.get<OrganizationListView>(this.basePath, { params });
    return response.data;
  }

  async getOrganization(organizationId: string): Promise<OrganizationProfile> {
    const response = await httpService.get<OrganizationProfile>(`${this.basePath}/${organizationId}`);
    return response.data;
  }

  async createOrganization(data: OrganizationProfile): Promise<OrganizationProfile> {
    const response = await httpService.post<OrganizationProfile>(this.basePath, data);
    return response.data;
  }

  async updateOrganization(organizationId: string, data: Partial<OrganizationProfile>): Promise<OrganizationProfile> {
    const response = await httpService.post<OrganizationProfile>(`${this.basePath}/${organizationId}`, data);
    return response.data;
  }

  async deleteOrganization(organizationId: string): Promise<any> {
    const response = await httpService.delete(`${this.basePath}/${organizationId}`);
    return response.data;
  }

  async uploadLogo(organizationId: string, file: File, oldS3Key?: string | null): Promise<OrganizationProfile> {
    const formData = new FormData();
    formData.append("file", file);
    const params: Record<string, any> = {};
    if (oldS3Key) {
      params.old_s3_key = oldS3Key;
    }
    const response = await httpService.post<OrganizationProfile>(
      `${this.basePath}/${organizationId}/logo`,
      formData,
      {
        params,
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  }
}

const client = new OrganizationClient();
export default client;
